import { Check, ArrowRight, PlayCircle, TrendingUp, CheckCircle2 } from 'lucide-react';

const HIGHLIGHTS = ['100% web', 'Sin instalaciones', 'Historial permanente', 'Conciliaciones ilimitadas'];

function DashboardMockup() {
  return (
    <div className="relative">
      <div className="absolute -inset-6 bg-gradient-to-tr from-brand-green/20 via-brand-blue/10 to-transparent blur-2xl rounded-[2rem]" />
      <div className="relative rounded-2xl border border-slate-200 bg-white shadow-2xl overflow-hidden">
        {/* barra de ventana */}
        <div className="flex items-center gap-1.5 px-4 py-3 bg-slate-50 border-b border-slate-200">
          <span className="w-2.5 h-2.5 rounded-full bg-red-400" />
          <span className="w-2.5 h-2.5 rounded-full bg-amber-400" />
          <span className="w-2.5 h-2.5 rounded-full bg-green-400" />
          <span className="ml-3 text-xs text-slate-400 font-medium">app.conciliabanco.com</span>
        </div>

        <div className="p-5 space-y-4">
          {/* tarjetas KPI */}
          <div className="grid grid-cols-3 gap-3">
            {[
              { label: 'Movimientos', value: '4.812', color: 'text-navy-900' },
              { label: 'Conciliados', value: '4.760', color: 'text-brand-green' },
              { label: 'Pendientes', value: '52', color: 'text-amber-500' },
            ].map((k) => (
              <div key={k.label} className="rounded-xl bg-slate-50 border border-slate-100 p-3">
                <p className="text-[11px] text-slate-500 font-medium">{k.label}</p>
                <p className={`text-lg font-bold ${k.color}`}>{k.value}</p>
              </div>
            ))}
          </div>

          {/* gráfica simulada */}
          <div className="rounded-xl border border-slate-100 p-4">
            <div className="flex items-center justify-between mb-3">
              <p className="text-xs font-semibold text-slate-600">Conciliación mensual</p>
              <span className="flex items-center gap-1 text-[11px] font-semibold text-brand-green">
                <TrendingUp size={13} /> 98.9%
              </span>
            </div>
            <div className="flex items-end gap-2 h-20">
              {[40, 65, 50, 80, 60, 95, 75].map((h, i) => (
                <div
                  key={i}
                  className="flex-1 rounded-t-md bg-gradient-to-t from-navy-800 to-brand-blue"
                  style={{ height: `${h}%` }}
                />
              ))}
            </div>
          </div>

          {/* lista de estado */}
          <div className="rounded-xl border border-slate-100 divide-y divide-slate-100">
            {[
              ['Extracto bancario Bancolombia.xlsx', 'Cruzado'],
              ['Auxiliar contable marzo.xlsx', 'Cruzado'],
              ['3 partidas conciliatorias', 'Revisar'],
            ].map(([name, status]) => (
              <div key={name} className="flex items-center justify-between px-3 py-2.5">
                <span className="text-xs text-slate-600 truncate pr-2">{name}</span>
                <span
                  className={`flex items-center gap-1 text-[11px] font-semibold shrink-0 ${
                    status === 'Cruzado' ? 'text-brand-green' : 'text-amber-500'
                  }`}
                >
                  <CheckCircle2 size={12} /> {status}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Hero({ onEmpezar, onVerDemo }) {
  return (
    <section id="inicio" className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-14 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-brand-green/10 text-brand-greenDark text-xs font-semibold px-3 py-1.5">
            Conciliación bancaria inteligente
          </span>

          <h1 className="mt-5 text-4xl md:text-5xl lg:text-[3.4rem] font-extrabold tracking-tight text-navy-900 leading-[1.1]">
            Concilia miles de movimientos bancarios en menos de un minuto.
          </h1>

          <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-xl">
            Automatiza la conciliación bancaria de tu empresa, reduce errores y ahorra horas
            de trabajo cada mes.
          </p>

          <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2">
            {HIGHLIGHTS.map((h) => (
              <li key={h} className="flex items-center gap-1.5 text-sm font-medium text-slate-700">
                <Check size={16} className="text-brand-green" /> {h}
              </li>
            ))}
          </ul>

          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <button
              onClick={onEmpezar}
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-brand-green px-7 py-3.5 text-base font-semibold text-white shadow-lg shadow-brand-green/20 hover:bg-brand-greenDark hover:shadow-xl hover:-translate-y-0.5 transition-all"
            >
              Empieza ahora <ArrowRight size={18} />
            </button>
            <button
              onClick={onVerDemo}
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-white border border-slate-200 px-7 py-3.5 text-base font-semibold text-navy-900 hover:border-navy-300 hover:-translate-y-0.5 transition-all"
            >
              <PlayCircle size={18} /> Ver demostración
            </button>
          </div>
        </div>

        <DashboardMockup />
      </div>
    </section>
  );
}
